import { createStore } from 'jotai/vanilla';
import { createContext } from 'react';
import type { SerialCommandQueue } from '../domainLogic/createSerialCommandQueue';

export type SidePanelSystemStore = ReturnType<typeof createStore>;
export type SidePanelCommandHandler = (input: unknown, context: unknown) => unknown | Promise<unknown>;
export type SidePanelSystemContextValue = {
    store: SidePanelSystemStore;
    commandHandlers: Map<string, Map<string, SidePanelCommandHandler>>;
    onSessionClose?: () => void;
    controlQueue: SerialCommandQueue;
};

export const SidePanelSystemContext = createContext<SidePanelSystemContextValue | null>(null);
